import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web.drivingzone/web.drivingzone/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web.drivingzone/web.drivingzone/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingzone/web.drivingzone/src/app/exam/road/client.tsx");
